import { Box } from '@mui/material';
import { forwardRef } from 'react';

import { observer } from 'mobx-react-lite';
import { UserData } from '@codefluegel/wowis-rest-typescript-client';
import CardContainer from '../../components/cards/CardContainer';
import PersonDataForm, {
  GetFormHandle,
} from '../../components/forms/PersonDataForm';
import useMedia from '../../hooks/useMedia';

interface Props {
  user: UserData | undefined;
  onDataChanged: (dataChanged: boolean) => void;
}

const PersonalData = observer(
  forwardRef<GetFormHandle, Props>((props, ref) => {
    const { onDataChanged, user } = props;
    const isMobile = useMedia('md');

    const title = 'Personenbezogene Daten';

    return (
      <Box p={1} height={1} flexGrow={1} mb={isMobile ? 2 : 4}>
        <CardContainer
          title={title}
          customStyle={{
            sx: {
              margin: 0,
            },
          }}
          iconOn
          iconName={title}
        >
          <PersonDataForm
            ref={ref}
            user={user}
            onChange={() => onDataChanged(true)}
          />
        </CardContainer>
      </Box>
    );
  }),
);

export default PersonalData;
